import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/registration/registrations',
    method: 'get',
    params: query
  })
}
